export const SALES_QUOTES = [
  "Every call you make today is a doorway to someone's dream home.",
  "Success in sales is the result of discipline, dedication and daily follow-ups.",
  "Don't count the leads — make every lead count.",
  "Your attitude, not your aptitude, will determine your altitude.",
  "Great salespeople build relationships first; the sale follows naturally.",
  "Today's follow-up is tomorrow's booking.",
  "Winners are not people who never fail, but people who never quit.",
  "Every 'no' brings you one step closer to a 'yes'.",
  "Sell the dream, serve the customer, and success will chase you.",
  "The best time to follow up was yesterday. The next best time is now.",
  "Believe you can, and you're halfway there.",
  "Excellence is not an act, it's a habit — show up strong every day.",
  "A satisfied customer is the best business strategy of all.",
  "Push yourself, because no one else is going to do it for you.",
  "Opportunities don't happen. You create them — one call at a time.",
  "Your energy introduces you before you even speak.",
  "Small daily improvements lead to stunning results.",
  "Stay positive, work hard, make it happen.",
  "The harder you work, the luckier you get.",
  "Dream big, hustle harder, close stronger.",
  "Consistency beats talent when talent doesn't follow up.",
  "Treat every client like your only client.",
  "Champions keep playing until they get it right.",
  "Make today so productive that yesterday gets jealous.",
  "You don't close a sale — you open a relationship.",
  "Action is the foundational key to all success.",
  "Be so good they can't ignore you.",
  "Every expert was once a beginner. Keep going.",
  "Focus on being productive, not just busy.",
  "Success is walking from failure to failure with no loss of enthusiasm.",
];

export function pickQuote() {
  return SALES_QUOTES[Math.floor(Math.random() * SALES_QUOTES.length)];
}

export function getGreeting() {
  const h = new Date().getHours();
  if (h < 12) return { text: 'Good Morning', icon: 'Sunrise' };
  if (h < 17) return { text: 'Good Afternoon', icon: 'Sun' };
  return { text: 'Good Evening', icon: 'Moon' };
}
